import { render, staticRenderFns } from "./apps-apis-plan.vue?vue&type=template&id=16fa288a&scoped=true"
import script from "./apps-apis-plan.vue?vue&type=script&lang=js"
export * from "./apps-apis-plan.vue?vue&type=script&lang=js"
import style0 from "./apps-apis-plan.vue?vue&type=style&index=0&id=16fa288a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa288a",
  null
  
)

export default component.exports